import React from "react"; // eslint-disable-line no-unused-vars
import ReactDOM from "react-dom";
import AuthProvider from "./components/authProvider";
import App from "./components/app";
import { Provider } from "./store/provider";
import { getSavedQuote, getQuoteDetails } from "./store/actions";

if (process.env.NODE_ENV === "development") {
  console.log("TB-CHECKOUT: Loading");
}

const getQueryParams = (params, url) => {
  let href = url;
  let reg = new RegExp("[?&]" + params + "=([^&#]*)", "i");
  let queryString = reg.exec(href);
  return queryString ? decodeURI(queryString[1]) : null;
};

let render = function (app, theme, cart, quoteid, quoteDetails) {
  ReactDOM.render(
    <React.Fragment>
      <AuthProvider>
        <Provider cart={cart} quoteid={quoteid} quoteDetails={quoteDetails}>
          <App theme={theme} />
        </Provider>
      </AuthProvider>
    </React.Fragment>,
    app
  );
};

let loadApp = function () {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CHECKOUT: Initializing React component");
  }
  let app = document.getElementById("tbcheckout");
  if (app) {
    let quoteid = getQueryParams("quoteid", location.href);
    getQuoteDetails(quoteid).then((quoteDetails) => {
      getSavedQuote(quoteid).then((cart) => {
        fetch(process.env.THEME_URL)
          .then((response) => response.json())
          .then((theme) => {
            render(app, theme, cart, quoteid, quoteDetails);
          })
          .catch((error) => {
            if (process.env.NODE_ENV === "development") {
              console.log("TB-QUOTEREVIEW: ", error);
            }
            render(app, {}, cart, quoteid, quoteDetails);
          });
      });
    });
  } else {
    if (process.env.NODE_ENV === "development") {
      console.log("TB-CHECKOUT: No element to insert component into");
    }
  }
};
if (document.readyState === "loading") {
  if (process.env.NODE_ENV === "development") {
    console.log("TB-CHECKOUT: Waiting for document ready state");
  }
  document.addEventListener("DOMContentLoaded", loadApp);
} else {
  loadApp();
}
